import cmp from '../../lib/cmp';
import template from './sm-landing-appstore-app-1-rating-charts.template.js';
import './sm-landing-appstore-app-1-rating-charts.less';



export default cmp(null, template);



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-rating-charts/sm-landing-appstore-app-1-rating-charts.js